import { InputAdornment, Stack, Typography } from '@mui/material';
import Table, { Object } from 'components/Common/StyledTable';
import TextInput from 'components/Common/TextInput';

import { DateFilter } from './DateFilter';
import { ReactElement } from 'react';
interface ParishonerActivityProps {
    navigationHandler: Function;
    records: Array<any>;
    columns: Array<{ id: string; label: string }>;
    textInputPlaceholders?: Array<string>;
    showDeleteCell?: boolean;
    onDeleteClick?: (value: Object) => void;
    setFilter?: any;
    filter?: any;
    defaultPagination?: boolean;
    disabledDateFilter?: boolean;
    value?: string | number;
    onTemplatebuttonclick?: () => void;
    getStartedTemplate?: boolean;
    templateButtonText?: string;
    loading?: boolean;
    serverSidePagination?: boolean;
    totalCount?: number;
    activityHeader?: ReactElement;
    showLoading?: boolean;
}

function ActivityContainer({
    navigationHandler,
    records,
    columns,
    textInputPlaceholders,
    showDeleteCell,
    onDeleteClick,
    setFilter,
    filter,
    defaultPagination,
    disabledDateFilter,
    value,
    onTemplatebuttonclick,
    getStartedTemplate,
    templateButtonText,
    loading,
    serverSidePagination,
    totalCount,
    activityHeader,
    showLoading,
}: ParishonerActivityProps) {
    return (
        <Stack px={2} sx={{ backgroundColor: 'white', width: '100%' }}>
            <div style={{ paddingTop: 8, marginTop: 8 }}>
                {/* TODO:  Remove the turnery operator operator and implement activity header in whole app */}
                {activityHeader ? (
                    activityHeader
                ) : (
                    <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 12 }}>
                        <TextInput
                            backgroundColor="#F2F2F6"
                            height={50}
                            width={'30%'}
                            icon={null}
                            disabled
                            placeholder={textInputPlaceholders?.[0]}
                            InputProps={{
                                endAdornment: !loading && <InputAdornment position="end">{value}</InputAdornment>,
                            }}
                        />
                        {!showDeleteCell && (
                            <TextInput
                                backgroundColor="#F2F2F6"
                                height={50}
                                width={'30%'}
                                icon={null}
                                placeholder={textInputPlaceholders?.[1]}
                            />
                        )}
                    </div>
                )}
                <div style={{ display: 'flex', flexDirection: 'row', marginBottom: 12 }}>
                    {!showDeleteCell && (
                        <div>
                            <Typography>Recent Activity</Typography>
                            <DateFilter disabled={disabledDateFilter} setFilter={setFilter} filter={filter} />
                        </div>
                    )}
                    {/* <TextInput
                        height={50}
                        backgroundColor="#F2F2F6"
                        sx={{ ml: !showDeleteCell ? 2 : 0, fontSize: 20, fontWeight: 400 }}
                        placeholder={textInputPlaceholders[2]}
                    /> */}
                </div>
                <Table
                    onDeleteClick={onDeleteClick}
                    showDeleteCell={showDeleteCell}
                    successValue="Complete"
                    navigationHandler={navigationHandler}
                    loadData={(filters: any) => setFilter && setFilter((pre: any) => ({ ...pre, ...filters }))}
                    defaultPagination={defaultPagination}
                    columns={columns}
                    data={records}
                    onTemplatebuttonclick={onTemplatebuttonclick}
                    getStartedTemplate={getStartedTemplate}
                    templateButtonText={templateButtonText}
                    parentOffset={filter?.offset}
                    loading={loading}
                    serverSidePagination={serverSidePagination}
                    totalCount={totalCount}
                    showLoading={showLoading}
                />
            </div>
        </Stack>
    );
}

export default ActivityContainer;
